export class HTTPTransport {
    formatter;
    logBaseUrl;
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(formatter, logBaseUrl) {
        this.formatter = formatter;
        this.logBaseUrl = logBaseUrl;
    }
    write(appLog) {
        const log = this.formatter.format(appLog);
        return fetch(this.logBaseUrl, {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify({ error: log }),
        }).catch(err => console.error(err));
    }
}
//# sourceMappingURL=HTTPTransport.js.map